import { connect } from 'react-redux';
import { Card } from 'react-bootstrap';
import BaseFeature from './BaseFeature';
import PropertyPicker from './components/PropertyPicker';
import { MAINS_DIM } from '../../../../../../utils/constantFeatures';
import DraggableAreaChart from './charts/DraggableAreaChart';
import { getErrorIssues } from '../../../../../../utils/validationSummary';

class MainsDIM extends BaseFeature {

    constructor(props) {
        super(props);

        this.state = {
            properties: Object.assign({}, this.props.properties)
        };

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(propertyName, value) {

        const v = value;
        this.props.handleChange(propertyName, v);

        this.setState({ properties: this.props.properties });
    }

    render() {
        const startVoltage = this.props.properties[MAINS_DIM.startVoltage];
        const startLevel = this.props.properties[MAINS_DIM.startLevel];
        const stopVoltage = this.props.properties[MAINS_DIM.stopVoltage];
        const stopLevel = this.props.properties[MAINS_DIM.stopLevel];
        // const dgDl = this.props.properties['dg.dl'];

        const dataChart = this.getDataChart(this.props.properties);
        return (
            <div className="flex-row">
                <Card className={this.getClassName([startVoltage, startLevel, stopVoltage, stopLevel])}>
                    <div className="card-header-feature">
                        {'Settings'}
                    </div>
                    <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem' }}>
                        <PropertyPicker
                            style={{ marginTop: '0.5rem' }}
                            property={startVoltage}
                            title={startVoltage.info.displayName}
                            measureUnit={'V'}
                            min={Math.max((parseInt(stopVoltage.value) + 30), startVoltage.valueMeta.min)}
                            max={startVoltage.valueMeta.max}
                            step={1}
                            handleChange={this.handleChange} />
                        <PropertyPicker
                            style={{ marginTop: '0.5rem' }}
                            property={startLevel}
                            title={'Start Level'}
                            measureUnit={'%'}
                            min={Math.max(stopLevel.value, startLevel.valueMeta.min)}
                            max={startLevel.valueMeta.max}
                            step={1}
                            handleChange={this.handleChange} />
                        <PropertyPicker
                            style={{ marginTop: '0.5rem' }}
                            property={stopVoltage}
                            title={stopVoltage.info.displayName}
                            measureUnit={'V'}
                            min={stopVoltage.valueMeta.min}
                            max={Math.min((parseInt(startVoltage.value) - 30), stopVoltage.valueMeta.max)}
                            step={1}
                            handleChange={this.handleChange} />
                        <PropertyPicker
                            style={{ marginTop: '0.5rem' }}
                            property={stopLevel}
                            title={stopLevel.info.displayName}
                            measureUnit={'%'}
                            min={stopLevel.valueMeta.min}
                            max={Math.min(startLevel.value, stopLevel.valueMeta.max)}
                            step={1}
                            handleChange={this.handleChange} />
                    </Card.Body>
                </Card>

                <Card className="card-feature-component" style={{ width: '80%' }}>
                    <div className="card-header-feature">
                    </div>
                    <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem' }}>
                        <DraggableAreaChart
                            containsErrors={getErrorIssues(this.props.issues, this.props.properties).length > 0}
                            properties={this.props.properties}
                            dataChart={dataChart}
                            x={{ 'title': 'Mains Voltage (V)' }}
                            y={{ 'title': 'Output Level (%)' }}
                            max={{ y: 120 }}
                            tickValues={{ x: [], y: [] }}
                            xLabels={this.getXLabels(dataChart)}
                            yLabels={this.getYLabels(dataChart)}
                            handleChange={this.handleChartChange} />
                    </Card.Body>
                </Card>
            </div>
        );
    }

    getXLabels(dataChart) {

        const labels = [];
        const smallLabels = [];
        const ticks = [];

        dataChart.forEach((el, index) => {
            switch (el.timeLabel) {
                case 'stopVoltage-0':
                    ticks.push(el.x);
                    labels.push({ label: el.x, x: el.x });
                    break;
                case 'startVoltage-0':
                    ticks.push(el.x);
                    labels.push({ label: el.x, x: el.x });
                    break;
                default:
                    break;
            }
        });

        return { labels: labels, smallLabels: smallLabels, ticks: ticks };
    }

    getYLabels() {
        const labels = {};

        //insert max label if max value is not present
        const max = this.props.properties[MAINS_DIM.startLevel].value;
        if (!labels[max]) {
            labels[max] = { label: max, y: max };
        }

        //insert min label if min value is not present
        const min = this.props.properties[MAINS_DIM.stopLevel].value;
        if (!labels[min]) {
            labels[min] = { label: min, y: min };
        }

        return Object.keys(labels).map((key) => { return labels[key]; });
    }

    getDataChart(properties) {

        let dataChart = [{}, {}, {}, {}, {}];

        dataChart[0] = {
            x: 0,
            y: 0
        }

        dataChart[1] = {
            x: 0,
            y: +properties[MAINS_DIM.stopLevel].value
        }

        dataChart[2] = {
            x: +properties[MAINS_DIM.stopVoltage].value,
            y: +properties[MAINS_DIM.stopLevel].value,
            timeLabel: "stopVoltage-0",
        }

        dataChart[3] = {
            x: +properties[MAINS_DIM.startVoltage].value,
            y: +properties[MAINS_DIM.startLevel].value,
            timeLabel: "startVoltage-0",
        }

        dataChart[4] = {
            x: dataChart[3].x + 100,
            y: +properties[MAINS_DIM.startLevel].value
        }

        // Setting data for the chart
        // dataChart = dataChart.filter((d) => d.x && d.y && d.x !== "Off" && d.y !== "Off" );

        return dataChart;
    }

}

const mapStateToProps = (state, ownProps) => {
    return {
        validationSummary: state.project.validationSummary,
        issues: state.project.issueByProperty,
    };
};

const mapDispatchToProps = {
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MainsDIM);
